import WorkPreferences from './WorkPreferences';
export default WorkPreferences;